// ABOUTME: Pure selection helpers for ShDataGrid3: resolving ticked ids to full row objects across
// ABOUTME: pages, and computing the selection after the header (select-all) checkbox is clicked.

// The ticked ids as a Map of id → row. Rows on the current page come from the data; rows ticked on
// an earlier page are no longer in the data, so they come from the previous result.
export const resolveSelectedRows = (selectedIds, rows, previous) => {
    const rowsById = new Map((rows || []).map((row) => [row.id, row]));
    const resolved = new Map();
    selectedIds.forEach((id) => {
        const row = rowsById.get(id) ?? previous.get(id);
        if (row) resolved.set(id, row);
    });
    return resolved;
};

// By default the header checkbox replaces the whole selection with the current page (or clears it).
// With keepAcrossPages it only adds or removes the current page's rows, leaving other pages' ticks.
export const toggleAllSelection = (selectedIds, pageIds, keepAcrossPages) => {
    const allSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id));
    if (!keepAcrossPages) return allSelected ? [] : pageIds;
    if (allSelected) return selectedIds.filter((id) => !pageIds.includes(id));
    return [...selectedIds, ...pageIds.filter((id) => !selectedIds.includes(id))];
};
